import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/DashboardAction";

export const CompanyBalanceModal = ({ setShow, show, setSwalProps }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [companyEdit, setCompanyEdit] = useState();
  const dashboardState = useSelector(
    ({ dashboard }) => dashboard,
    shallowEqual
  );
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (show)
      dispatch(
        actions.fetchCompanyBalanceList({ action: "companybalancelist" })
      );
  }, [show]);

  const handleSave = () => {
    dispatch(
      actions.updateCompanyBalance({
        action: "companybalanceupdate",
        ...companyEdit,
        editable: undefined,
      })
    ).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setCompanyEdit(undefined);
        dispatch(
          actions.fetchCompanyBalanceList({ action: "companybalancelist" })
        );
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({
            id: "updateSuccessfully",
          }),
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <>
      <Modal
        show={!!companyEdit}
        onHide={() => setCompanyEdit(undefined)}
        centered
        data-bs-theme={mode}
        size="lg"
        className="zIndex-9999"
        backdropClassName="zIndex-9999"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {companyEdit?.companycode + " "}
            {intl.formatMessage({
              id: "companyBalance",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label class="mb-2 text-input-label">
              {intl.formatMessage({ id: "amount" })}
            </label>
            <input
              type="number"
              className="form-control"
              value={companyEdit?.balance ?? 0}
              placeholder={intl.formatMessage({ id: "amount" })}
              onChange={(e) => {
                setCompanyEdit({ ...companyEdit, balance: e.target.value });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSave();
                }
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleSave()}
          >
            {intl.formatMessage({ id: "update" })}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setCompanyEdit(undefined)}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "companyBalance",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {dashboardState.companyBalanceList &&
              dashboardState.companyBalanceList.companyBalanceLists.map(
                (companyBalance) => (
                  <div
                    className="col-md-4 p-2"
                    key={companyBalance.companycode}
                  >
                    <div
                      className="dashboard-container rounded border shadow-lg p-2 cursor-pointer position-relative"
                      onClick={() =>
                        companyBalance.editable === "true"
                          ? setCompanyEdit(companyBalance)
                          : {}
                      }
                    >
                      {companyBalance.editable === "true" && (
                        <div className="position-absolute p-1 top-0 end-0">
                          <i className="bi bi-pen" />
                        </div>
                      )}
                      <div className="mb-3 text-center text-truncate">
                        {companyBalance.companycode}
                      </div>
                      <div
                        className={`fw-bold text-center ${
                          parseFloat(companyBalance.balance ?? "0") <= 5000
                            ? "text-danger"
                            : ""
                        }`}
                      >
                        {companyBalance.balance}
                      </div>
                    </div>
                  </div>
                )
              )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
